"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachTriggerDate = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const attachTriggerDate = ({ config, triggerDate, }) => {
    const { triggerDates, globalRecurringDateConfigs: rawRecurDateConfigs, athenaQueries: rawAthenaQueries, athenaRecurringQueries: rawAthenaRecurringQueries, postgresQueries: rawPostgresQueries, intermediateFields: rawIntermediateFields, } = config;
    const errors = [];
    // make trigger date available to queries
    const athenaQueries = rawAthenaQueries.map((query) => {
        if (query.variables.find((variable) => variable.name === 'triggerDate')) {
            errors.push(`Trigger date should not be defined in athena query variables for ${query.query.name}`);
        }
        return {
            ...query,
            variables: [
                { name: 'triggerDate', value: triggerDate, parseNumber: true },
                ...query.variables,
            ],
        };
    });
    // make trigger date available to Athena recurring queries
    const athenaRecurringQueries = rawAthenaRecurringQueries.map((query) => {
        if (query.variables.find((variable) => variable.name === 'triggerDate')) {
            errors.push(`Trigger date should not be defined in athena recurring query variables for ${query.name}`);
        }
        return {
            ...query,
            variables: [
                { name: 'triggerDate', value: triggerDate, parseNumber: true },
                ...query.variables,
            ],
        };
    });
    // make trigger date available to postgres variables
    const postgresQueries = rawPostgresQueries.map((query) => {
        if (query.variables.find((variable) => variable.name === 'triggerDate')) {
            errors.push(`Trigger date should not be defined in postgres query variables for ${query.name}`);
        }
        return {
            ...query,
            variables: [
                { name: 'triggerDate', value: triggerDate, parseNumber: true },
                ...query.variables,
            ],
        };
    });
    if (rawIntermediateFields.find((intermediateFields) => intermediateFields.field === 'triggerDate')) {
        errors.push('Trigger date should not be defined in intermediate fields.');
    }
    // make trigger date available to intermediate fields
    const intermediateFields = [
        {
            field: 'triggerDate',
            config: {
                formula: `"${triggerDate}"`,
                type: 'formula',
                engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
            },
        },
        ...rawIntermediateFields,
    ];
    if (errors.length) {
        return {
            config: null,
            errors,
        };
    }
    return {
        config: {
            triggerDates,
            globalRecurringDateConfigs: rawRecurDateConfigs,
            athenaQueries,
            athenaRecurringQueries,
            postgresQueries,
            intermediateFields,
        },
        errors,
    };
};
exports.attachTriggerDate = attachTriggerDate;
//# sourceMappingURL=attach.js.map